var Base = require('_js/base'),
  $ = require('jquery');

function FooterViewModel() {
  this.init();
}

FooterViewModel.prototype = new Base();

FooterViewModel.prototype.init = function() {
  $(function() {
    var $accordions = $('.main-footer .accordion-single header');
    $accordions.on('click', function() {
      $(this)
        .parent()
        .toggleClass('active');
    });
  });
};

module.exports = FooterViewModel;
